export var publicDataProp = function (initialPublicData) {
    var publicData = initialPublicData !== null && initialPublicData !== void 0 ? initialPublicData : {};
    if (!publicData.APP) {
        publicData.APP = {};
    }
    if (!publicData.COMPONENT) {
        publicData.COMPONENT = {};
    }
    return publicData;
};
//# sourceMappingURL=publicDataProp.js.map